import Repository from "./Repository";

const resource = "/dropdown";
export default {
  get() {
    return Repository.get(`${resource}`);
  }
};
